/**
 * Portée d'un rôle, en miroir de `data/models/canteenmembership.py::SCOPE_BY_JOB` (backend).
 *
 * Deux valeurs, jamais une troisième : un rôle de portée `SINGLE_CANTEEN` (SUPERVISOR, WORKER)
 * sélectionne une cantine à la fois et monte `DashboardContextHeader` ; un rôle de portée
 * `MULTI_CANTEEN` (COOK, NUTRITIONIST, SURPLUSMANAGER) agrège ses cantines de rattachement et
 * monte `MultiCanteenContextHeader`. `DashboardHeader.vue` est le seul point qui lit cette table
 * pour choisir entre les deux : aucune vue de dashboard ne doit coder la portée en dur.
 *
 * Duplication assumée avec le backend, faute d'un point d'exposition API dédié (la portée est
 * déjà portée par `scope` sur chaque élément de `loggedUser.canteenMemberships`, mais un rôle
 * peut être affiché avant tout rattachement effectif — cf. le scénario « Aucun rattachement »).
 */

export const RoleScope = Object.freeze({
  SINGLE_CANTEEN: "SINGLE_CANTEEN",
  MULTI_CANTEEN: "MULTI_CANTEEN",
})

export const SCOPE_BY_JOB = Object.freeze({
  SUPERVISOR: RoleScope.SINGLE_CANTEEN,
  WORKER: RoleScope.SINGLE_CANTEEN,
  COOK: RoleScope.MULTI_CANTEEN,
  NUTRITIONIST: RoleScope.MULTI_CANTEEN,
  SURPLUSMANAGER: RoleScope.MULTI_CANTEEN,
})

/** Portée déclarée d'un rôle, ou `null` si le rôle n'est pas au référentiel du pivot. */
export function scopeOf(job) {
  return SCOPE_BY_JOB[job] || null
}
